import { Component, OnInit } from '@angular/core';
import { ContactSearchDto, initializeContactSearchDto } from 'src/app/contacts/shared/contact-search.dto';
import { Contact } from 'src/app/contacts/shared/contact.model';
import { FinancialServiceService } from 'src/app/revenue/shared/financial.service';
import { PagedResultGeneric } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ProfileService } from '../shared/profile.service';

@Component({
  selector: 'wl-profile-contact-records',
  templateUrl: './profile-contact-records.component.html',
  styleUrls: ['./profile-contact-records.component.less'],
    standalone: false
})
export class ProfileContactRecordsComponent implements OnInit {
  searchParams = this.initializedParams();
  contactRecordSearchResult: PagedResultGeneric<Contact>;
  exportingRecords = false;
  constructor(private _profileService: ProfileService, private _navigationService: NavigationService) {}

  ngOnInit(): void {}

  clear() {
    this.searchParams = this.initializedParams();
  }

  private initializedParams() {
    const searchDto = initializeContactSearchDto();
    return searchDto;
  }

  export() {
    this.exportingRecords = true;
    this._profileService
      .exportContactRecords(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exportingRecords = false;
      });
  }
}
